<template>
  <div class="note-book" v-show="show">
    <div class="mask-wrap">
      <button class="close-btn" @click="close">{{ t('stuManagement.notebookTips1') }}</button>
      <h2>{{ t('stuManagement.notebookTips2') }}</h2>
      
      <ul class="steps">
        <li 
          v-for="(item, key) in arr" 
          :key="key" 
          v-html="item"
          :style="{opacity: step == key? 1: 0}">
        </li>
      </ul>
      <div class="step-btn">
        <button :class="['next-btn', step == 0 && 'disabled']" @click="handlePrev">{{ t('stuManagement.notebookTips3') }}</button>
        <div class="page">({{step+1+'/'+arr.length}})</div>
        <button :class="['next-btn', step == arr.length - 1 && 'finished']" @click="handleNext">{{step == arr.length - 1? `${t('stuManagement.notebookTips4')}`: `${t('stuManagement.notebookTips5')}`}}</button>
      </div>
    </div>

    <div class="mg"></div>
    <!-- <div class="center">
      <div class="side" >
        <div class="place" :style="{opacity: 1}"></div>
        <div class="tit1" :style="{
          opacity: step == 0 || step == 1? .1: 1
        }"></div>
        <div class="tit2" :style="{
          opacity: step == 2? .1: 1
        }"></div>
        <div class="tit3" :style="{
          opacity: step == 3? .1: 1
        }"></div>
        <div class="tit4"></div>
        <div class="tit5" :style="{
          opacity: step == 10? 1: 0
        }"></div>
        <div class="tit6" :style="{
          opacity: step == 11? 1: 0
        }"></div>
      </div>
      <div class="title" >
        <div class="mg" :style="{flex: 1}"></div>
        <div class="title-box">
          <div class="tit1" :style="{
            opacity: step == 4? .1: 1
          }"></div>
          <div class="tit2" :style="{
            opacity:  step == 5? .1: 1
          }"></div>
          <div class="tit3" :style="{
            opacity: step == 6? .1: 1
          }"></div>
        </div>
      </div>
      <div class="cnt" >
        <div class="tit1" :style="{
          opacity: step == 7? .1: 1
        }"></div>
        <div class="tit2" :style="{
          opacity: step == 8 || step == 9 ? .4: 1
        }"></div>
      </div>
    </div> -->
    <div class="mg"></div>
</div>
</template>
<script>
import i18n from "@/locale/index";
export default {
  mixins: [i18n],
  props:{
    type: {
      default: 'hti',
      type: String
    },
  },
  data(){
    return {
      step: 0,
      show: false,
    }
  },
  mounted(){
    document.body.appendChild(this.$el);
  },
  watch: {
    show(val){
      document.body.style.overflow = val? 'hidden': 'auto'
    }
  },
  computed:{
    arr(){
      return [
        `${this.t('stuManagement.notebookTipsArr11')}<i>${this.t('stuManagement.notebookTipsArr12')}</i>${this.t('stuManagement.notebookTipsArr13')}`,
        `“<b>*</b>${this.t('stuManagement.notebookTipsArr21')}”${this.t('stuManagement.notebookTipsArr22')}`,
        `${this.t('stuManagement.notebookTipsArr31')}<span class="little-btn">${this.t('stuManagement.notebookTipsArr32')}</span>${this.t('stuManagement.notebookTipsArr33')}`,
        `${this.t('stuManagement.notebookTipsArr31')}<span class="little-btn">${this.t('stuManagement.notebookTipsArr41')}</span>${this.t('stuManagement.notebookTipsArr42')}`,
        `<b>${this.t('stuManagement.notebookTipsArr51')}</b>${this.t('stuManagement.notebookTipsArr52')}`,
        `${this.t('stuManagement.notebookTipsArr61')}<span class="little-npt">${this.t('stuManagement.notebookTipsArr62')}</span>${this.t('stuManagement.notebookTipsArr63')}`,
        `<i>${this.t('stuManagement.notebookTipsArr71')}</i>${this.t('stuManagement.notebookTipsArr72')}`,
        `${this.t('stuManagement.notebookTipsArr31')}<i class="little-btn">${this.t('stuManagement.notebookTipsArr81')}</i>${this.t('stuManagement.notebookTipsArr82')}`,
        `${this.t('stuManagement.notebookTipsArr31')}<span class="little-btn">${this.t('stuManagement.notebookTipsArr91')}</span>${this.t('stuManagement.notebookTipsArr92')}`,
        `${this.t('stuManagement.notebookTipsArr31')}<span class="little-btn">${this.t('stuManagement.notebookTipsArr101')}</span>${this.t('stuManagement.notebookTipsArr102')}`,
        `<span class="little-btn">${this.t('stuManagement.notebookTipsArr91')}</span>“<b>*</b>${this.t('stuManagement.notebookTipsArr111')}”${this.t('stuManagement.notebookTipsArr112')}“<b>*</b>${this.t('stuManagement.notebookTipsArr113')}”${this.t('stuManagement.notebookTipsArr114')}`,
        `<span class="little-btn">${this.t('stuManagement.notebookTipsArr91')}</span>“<b>*</b>${this.t('stuManagement.notebookTipsArr121')}”${this.t('stuManagement.notebookTipsArr122')}`,
      ];
    },
  },
  methods:{
    showNoteBook(){
      this.show = false;
      // let show = localStorage.getItem('showNoteBook')
      // show = parseInt(show)
      // if(show) {
      //   if(show >= this.arr.length - 1){
      //     return;
      //   }
      //   this.step = show;
      // }
      // this.show = true;
      
    },
    close(){
      this.show = false;
      localStorage.setItem('showNoteBook', this.arr.length)
    },
    handleNext(){
      if(this.arr.length - 1 == this.step){
        this.close()
      } else {
        this.step += 1;
        localStorage.setItem('showNoteBook', this.step)
      }
    },
    handlePrev(){
      if(this.step == 0) return;
      this.step -= 1;
      localStorage.setItem('showNoteBook', this.step)
    }
  }
}
</script>
<style lang="scss">
  $maskBgm: rgba(0,0,0,0.6);
  @mixin maskAttr{
    background: $maskBgm;
    transition: opacity .2s;
  }
  
  .note-book{
    z-index: 1000;
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    .mask-wrap{
      position: absolute;
      width: 452px;
      padding: 24px;
      border-radius: 2px;
      z-index: 1;
      background-color: rgba(255,255,255,1);
      box-shadow: rgba(255, 255, 255, 0.1) 0px 0px 5px 0px, rgba(255, 255, 255, 0.1) 0px 0px 1px 0px;
      .close-btn{
        display: block;
        background-color: #f0f0f0;
        color: #666;
        margin-left: auto;
        font-size: 12px;
        padding: 4px 4px;
        cursor: pointer;
        transition: color .25s;
        &:hover{
          color: #000;
        }

      }
      h2{
        margin: 24px 0 38px;
        font-size: 22px;
        text-align: center;
      }
      .steps{
        position: relative;
        height: 58px;
        padding-left: 16px;
        li{
          position: absolute;
          top: 0;
          padding-left: 8px;
          font-size: 14px;
          margin-bottom: 12px;
          transition: opacity .2s;
          list-style: decimal;
          .little-btn{
            font-size: 12px;
            padding: 1px 4px;
            background-color: var(--form-color-primary);
            border-radius: 2px;
            color: #fff;
            margin: 0 2px;
          }
          .little-npt{
            padding: 1px 4px;
            margin: 0 2px;
            font-size: 12px;
            color: #666;
            border: 1px solid #DCDFE6;
            border-radius: 2px;
          }
          i{
            padding: 0 4px 0 2px; 
          }
          b{
            font-weight: bold;
            color: var(--form-color-primary);
          }
        }
      }
      .check-wrap{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 12px;
        margin-right: -6px;
        .title{
          text-align: center;
          font-size: 12px;
          color: #333;
          margin-bottom: 10px;
          line-height: 1;
          margin-right: 12px;
        }
        .circle{
          border: 1px solid #999;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #fff;
          background-clip: content-box;
          padding: 2px;
          margin: 0 6px 6px;
          &.current{
            border-color: var(--form-color-primary);
          }
          &.checked{
            background-color: var(--form-color-primary);
            border-color: var(--form-color-primary);
          }
        }

      }
      .step-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 36px auto 0;
        .page{
          font-size: 12px;
        }
      }
      .next-btn{
        margin: 0 24px;
        width: 80px;
        height: 32px;
        font-size: 14px;
        cursor: pointer;
        background-color: #f0f0f0;
        color: #333;
        transition: color .25s;
        line-height: 1.12;
        border-radius: 2px;
        &:hover{
          color: var(--form-color-primary);
        }
        &.disabled{
          opacity: .5;
          cursor: no-drop;
          color: #333;
        }
        &.finished{
          background-color: var(--form-color-primary);
          color: #fff;
        }
      }
    }
    .mg{
      flex: 1;
      @include maskAttr;
      height: 100%;
    }
    .center{
      max-width: 1080px;
      width: 100%;
      height: 100%;
      .side{
        float: left;
        border: 14px solid $maskBgm;
        border-top: 0;
        width: 200px;
        height: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        .place {
          height: 54px;
          width: 100%;
          @include maskAttr;
        }
        .tit1{
          width: 100%;
          @include maskAttr;
          height: 80px;
        }
        .tit2{
          height: 48px;
          width: 100%;
          @include maskAttr;
        }
        .tit3{
          height: 50px;
          width: 100%;
          @include maskAttr;
        }
        .tit4{
          flex: 1;
          width: 100%;
          @include maskAttr;
        }
        .tit5{
          position: absolute;
          background-image: url('../../src/assets/step4.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 172px;
          height: 226px;
          left: 0;
          top: 54px;
          z-index: 1;
        }
        .tit6{
          position: absolute;
          background-image: url('../../src/assets/step5.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          height: 670px;
          left: 0;
          top: 54px;
          z-index: 1;
          width: 172px;
        }
      }
      .title{
        margin-left: 200px;
        height: 122px;
        display: flex;
        flex-direction: column;
        .title-box {
          height: 68px;
          display: flex;
          .tit1{
            @include maskAttr;
            height: 100%;
            width: 162px;
          }
          .tit2{
            @include maskAttr;
            height: 100%;
            flex: 1;
          }
          .tit3{
            @include maskAttr;
            height: 100%;
            width: 200px;
            margin-left: auto;
          }
        }
      }
      .cnt{
        margin-left: 200px;
        height: calc(100% - 68px);
        .tit1{
          width: 100%;
          height: 48px;
          @include maskAttr;
        }
        .tit2{
          width: 100%;
          height: calc(100% - 48px);
          @include maskAttr;
        }
      }
    }
  }
  @media screen and(max-width: 768px){
    .note-book{
      .center{
        @include maskAttr;
        .side, .title, .cnt{
          display: none;
        }
      }
    }
  }
</style>